import { render, staticRenderFns } from "./ChartRataRata.vue?vue&type=template&id=6b722475&"
import script from "./ChartRataRata.vue?vue&type=script&lang=js&"
export * from "./ChartRataRata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports